// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { BillingPlanStatus } from '@/billing/api/types';
import { PLAN_STATUS_CHIP_CONFIG } from '@/billing/components/billing-plan-status-constants';
import { Chip } from '@mui/material';

interface Props {
  status: BillingPlanStatus;
}

// Renders the standard Hardfin status chip for a billing plan's derived
// lifecycle state. Color and variant come from PLAN_STATUS_CHIP_CONFIG so
// the listing page, hub card, and project detail surfaces stay in
// lockstep.
export function BillingPlanStatusChip(props: Props) {
  const config = PLAN_STATUS_CHIP_CONFIG[props.status];
  return (
    <Chip
      size="small"
      label={config.label}
      variant={config.variant}
      color={config.color}
    />
  );
}
